import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { debounceTime, takeUntil } from 'rxjs/operators';

import { Subject, fromEvent } from 'rxjs';

@Component({
    selector: 'app-appeal-hiding-text',
    templateUrl: './appeal-hiding-text.component.html',
    styleUrls: ['./appeal-hiding-text.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AppealHidingTextComponent implements OnInit, OnDestroy {

	@Input()
	public title: string;
	@Input()
	public text?: string;

	@ViewChild('hiddenText', {static: true})
	public hiddenText: ElementRef;
	public isEllipsisText: boolean = false;
	/** Отображать кнопку Показать/Скрыть, если текст больше одной строки */
	public isVisibilityHiddenBtn: boolean = false;

	public appealOpen$$: Subject<void> = new Subject<void>();
	private ngUnsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private zone: NgZone,
	) { }

	public get buttonText(): string {
		return this.isEllipsisText ? 'Подробнее' : 'Скрыть';
	}

	public ngOnInit(): void {
		this.zone.runOutsideAngular(() => {
			fromEvent(window, 'resize')
				.pipe(
					debounceTime(800),
					takeUntil(this.ngUnsubscribe),
				)
				.subscribe(() => this.setVisibilityHiddenBtn());
		});

		this.appealOpen$$
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe(() => this.setVisibilityHiddenBtn());
	}

	public ngOnDestroy(): void {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}


	public toggleText(): void {
		this.isEllipsisText = !this.isEllipsisText;
		this.changeDetectorRef.detectChanges();
	}

	private setVisibilityHiddenBtn(): void {
		const element = this.hiddenText.nativeElement as HTMLElement;
		setTimeout(() => {
			this.isVisibilityHiddenBtn = this.isEllipsisText = element.getClientRects().length > 1;
			this.changeDetectorRef.detectChanges();
		});
	}

}
